import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SiteContext = createContext(null);

const FALLBACK = {
  company_name: "Robotic Lawnmower Experts",
  phone: "089 425 9690",
  email: "info@roboticlawnmowerexperts.ie",
  address: "Fyanstown, Kells, Co. Meath, A82 AV90",
  hours: "Mon–Fri 09:00–17:00, Sat by appointment",
  map_url:
    "https://www.google.com/maps/search/Robotic+Lawnmower+Experts/@53.726566,-6.822304,17z",
};

export function SiteProvider({ children }) {
  const [settings, setSettings] = useState(FALLBACK);

  useEffect(() => {
    api
      .get("/settings")
      .then((res) => setSettings({ ...FALLBACK, ...res.data }))
      .catch(() => setSettings(FALLBACK));
  }, []);

  return <SiteContext.Provider value={settings}>{children}</SiteContext.Provider>;
}

export const useSite = () => useContext(SiteContext);
